// Customer integration settings come from the tenant's saved configuration.
// Never put these credentials in public runtime-config.js or image build arguments.
function buildSonarqubeConfig(selectedId, accounts = []) {
  if (!selectedId) return { enabled: false };
  const account = accounts.find(item => item._id === selectedId);
  if (!account) throw new Error('Selected SonarQube configuration is unavailable. Refresh and select it again.');
  let url;
  try { url = new URL(account.sonarServer); } catch (_) { throw new Error('Configure a valid SonarQube server URL in Access Management.'); }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password)
    throw new Error('SonarQube requires an HTTP(S) URL without embedded credentials.');
  if (!account.sonarUsername || !account.sonarPassword || /^\*+$/.test(account.sonarPassword))
    throw new Error('Configure SonarQube credentials in Access Management before deploying.');
  return { enabled: true, serverUrl: account.sonarServer, username: account.sonarUsername, password: account.sonarPassword };
}
module.exports = { buildSonarqubeConfig };

